import "pfkl-vcollapse/vcollapse/vcollapse.min.js";
import _ from "lodash";
import { data } from "./sod-data";

jQuery(function ($) {
  if (!$("body").hasClass("sod-questionnaire-page")) {
    return;
  }
  console.log("SoD Questionnaire ready");

  function printQuestionnaire(elem) {
    const printArea = document.getElementById(elem);

    if (printArea) {
      const printWindow = window.open("", "PRINT", "height=800,width=800");
      printWindow.document.write(
        `<html>
          <head>
            <title>${document.title}</title>
            <link rel="stylesheet" href="/themes/custom/tema/dist/main.css" type="text/css">
          </head>
          <body>
        `
      );
      printWindow.document.write(document.getElementById(elem).innerHTML);
      printWindow.document.write(`</body>
      </html>`);

      var removeElements =
        printWindow.document.querySelectorAll(".removeOnPrint");
      for (var i = 0; i < removeElements.length; i++) {
        removeElements[i].style.display = "none";
      }

      printWindow.document.close(); // necessary for IE >= 10
      printWindow.focus(); // necessary for IE >= 10*/
      printWindow.print();

      // printWindow.close();
      // return true;
    }
  }

  $("#printQuestionnaireBtn").on("click", function () {
    //window.print();
    printQuestionnaire("bigQuestCont");
  });

  /*Show Report / Hide questions */
  $("#createQuestionnaireBtn").on("click", function () {
    var asd = $(".standardType");
    for (var i = 0; i < asd.length; i++) {
      //console.log(asd[i].innerHTML);
      if (asd[i].innerHTML === "") {
        $(asd[i]).closest(".standards").hide();
      }
    }
    $("#questionnaireContainer").show();
    $("#SoDQuestions").hide();
    $(this).hide();
    var main = document.getElementById("qreResultContainer");

    [].map
      .call(main.children, Object)
      .sort(function (a, b) {
        return +a.id.match(/\d+/) - +b.id.match(/\d+/);
      })
      .forEach(function (elem) {
        main.appendChild(elem);
      });

    $("a").attr("target", "_blank");

    var sourceItems = document.querySelectorAll("div.sourceItem a");

    sourceItems.forEach(function (item) {
      var url = item.getAttribute("href");
      item.innerHTML = url;
    });

    // $(".result-questionnaire-collapse").each(function (index) {
    //   $(this).vCollapse({
    //     onLoad: "none",
    //     any: true,
    //     speed: 300,
    //   });
    // });
  });

  $("#closeQuestionnaireBtn").on("click", function () {
    $("#questionnaireContainer").hide();
    $("#SoDQuestions").show();
    $("#createQuestionnaireBtn").css({
      display: "inline-block",
    });
  });

  /*******************TEMPLATING*******************/
  //creates Subcategories & Appends them when given Question Object
  function appendSubCategories(item) {
    const subCatId = item.SubCategoryID.replace(/\./g, "");
    $(`#sodTabContent${item.CategoryID} .tab-content--inner`).append(
      `<div class="subCategoryItem vcollapse-questionnaire vcollapse-questionnaire-container">
        <div class="subCatLinknCheck subcategory-toggle-container">
          <button class="${item.CategoryID} subcategoryCheckboxLabel subcategory-toggle collapse-toggle vcollapse-toggle"
            data-target="#panel${subCatId}"
          >
            <div>${item.SubCategoryID} ${item.SubCategory}</div>
            <div class="overArchingQuestion">Overarching Question: ${item.Overarching}</div>
          </button>
          <input type="checkbox" class="subCatCheck${item.CategoryID} subCategoryCheckBox" id="${subCatId}"/>
        </div>
        <div id="panel${subCatId}" class="subCategoryQuestionsCont collapse-content vcollapse-content">
          <div class="content-container"></div>
        </div>
      </div>`
    );
  }

  //creates Questions for Subcategories
  function appendQuestionsToSubCategories(item) {
    const subCatId = item.SubCategoryID.replace(/\./g, "");
    $(`#panel${subCatId} .content-container`).append(
      `<div class="questionItem">
        <label class="question questionText" for="${item.QuestionID}">${item.QuestionID} ${item.Question}</label>
        <input type="checkbox" class="questionCheck${subCatId} questionCheckBox" id="${item.QuestionID}"/>
      </div>`
    );
  }
  //groups question objects into categories
  const categories = _.groupBy(data, function (key) {
    var key = key.CategoryID;
    return key === "1" ? "1" : key === "2" ? "2" : key === "3" ? "3" : "4";
  });

  //gets first instance of each subcategory in each category
  // const filterSubCategories = _.isEqual("SubCategory");
  const filterSubCategories = (obj1, obj2) => {
    return obj1.SubCategory === obj2.SubCategory;
  };

  Object.keys(categories).map((key) => {
    const currentCat = categories[key];
    const subcategories = _.uniqWith(currentCat, filterSubCategories);
    _.map(subcategories, appendSubCategories);
  });

  //Append Questions to Subcategories
  _.map(data, appendQuestionsToSubCategories);
  /********************END TEMPLATING********************/
  /*******************CHECKBOX BEHAVIOR*******************/
  function appendQuestionItem(item) {
    const ID = item.SubCategoryID.replace(/\./g, "");
    const location = $(`#questionTargetDiv${ID} .content-container`);
    const questionId = item.QuestionID.replace(/\./g, "");

    const questionItem = `<div class="questionItem" id="question${questionId}">
      <div class="questionHeading">${item.QuestionID} ${item.Question}</div>
      <div class="questionInfo">
        <div class="questionInfo--item whatToLookFor">
          <div class="questionInfo--title">What to look for</div>
          <div class="questionInfo--content" id="whatToLookFor${questionId}"></div>
        </div>
        <div class="questionInfo--item sources">
          <div class="questionInfo--title">Sources</div>
          <div class="questionInfo--content" id="sources${questionId}"></div>
        </div>
        <div class="questionInfo--item standards">
          <div class="questionInfo--title">Standards of Good Practice</div>
          <div class="questionInfo--content" id="standards${questionId}"></div>
        </div>
      </div>
    </div>`;
    location.append(questionItem);

    const whatToLookForItems = {
      Laws: item["WhatToLookForLAWS"],
      Practice: item["WhatToLookForPractice"],
      "Negative Indicators": item["WhatToLookForNEG"],
      "Positive Indicators": item["WhatToLookForPOS"],
      "Positive and Negative Indicators": item["WhatToLookForPOSNEG"],
      Implementation: item["WhatToLookForImplementation"],
    };
    const whatToLookForTarget = $(`#whatToLookFor${questionId}`);
    Object.keys(whatToLookForItems).map((key) => {
      const keyValue = whatToLookForItems[key];
      if (keyValue !== null) {
        const template = `<div class="whatToLookForItem">
          <p class="wTitle">${key}</p>
          <p class="wContent">${keyValue}</p>
        </div>`;
        whatToLookForTarget.append(template);
      }
    });

    const sourcesTarget = $(`#sources${questionId}`);
    function appendSources(s) {
      let list = `<div class="groupedItems sourceGroup">
        <div class="groupedItems--type sourceType">${s.type}</div>
        <ul class="groupedItems--list">`;
      var sItems = s.SourceItems;
      for (var i = 0; i < sItems.length; i++) {
        list += `<li class="sourceItem">${sItems[i]}</li>`;
      }
      list += `</ul>
      </div>`;
      sourcesTarget.append(list);
    }
    _.map(item.Sources, appendSources);

    const standardsTarget = $(`#standards${questionId}`);
    function appendStandards(s) {
      let list = `<div class="groupedItems standardGroup">
        <div class="groupedItems--type standardType">${s.type}</div>
        <ul class="groupedItems--list">`;
      var sItems = s.StandardItems;
      for (var i = 0; i < sItems.length; i++) {
        list += `<li class="standardItem">${sItems[i]}</li>`;
      }
      list += `</ul>
      </div>`;
      standardsTarget.append(list);
    }
    _.map(item.Standards, appendStandards);
  }

  // Result - append main category 1, 2, etc..
  function appendCategory(location, item) {
    const ID = item.SubCategoryID.replace(/\./g, "");
    const catId = item.CategoryID.replace(/\./g, "");
    const subCategoryContainerID = `subCatContainer${catId}`;
    const category = `<div class="category" id="questionnaireCategory${item.CategoryID}">
      <div class="CategoryHeading" id="categoryHeading${ID}">
        <div class="categoryQuestionnaireNumber">${item.CategoryID}</div>
        <div class="categoryQuestionnaireLabel">${item.Category}</div>
      </div>
      <div class="subCatContainer" id="${subCategoryContainerID}"></div>
    </div>`;
    location.append(category);
  }

  // Result - append sub category 1.1, 1.2, etc..
  function appendSubCategory(location, item) {
    const ID = item.SubCategoryID.replace(/\./g, "");
    const catId = item.CategoryID.replace(/\./g, "");
    const subCategoryContainerID = `subCatContainer${catId}`;
    const subCategoriesDIV = $(`#${subCategoryContainerID}`);
    const subCategory = `<div class="subCategory result-questionnaire-collapsex" id="subCat${ID}">
      <div class="subCategoryHeading vcollapse-togglex" data-target="#questionTargetDiv${ID}">
        <div class="subCategoryQuestionnaireLabel">
          <div class="subCategoryQuestionnaireLabelText">${item.SubCategoryID} ${item.SubCategory}</div>
          <div class="overArchingQuestionnaireQuestion">
            <span>Overarching Question: </span>
            ${item.Overarching}
          </div>
        </div>
      </div>
      <div class="subCatQuestions vcollapse-contentx" id="questionTargetDiv${ID}">
        <div class="content-container wyswyg-content"></div>
      </div>
    </div>`;
    subCategoriesDIV.append(subCategory);
  }

  function appendToQuestionnaire(location, item) {
    //appendQuestionItem(item);
    const ID = item.CategoryID.replace(/\./g, ""); // example: 1
    const subCatID = item.SubCategoryID.replace(/\./g, ""); // example: 11
    const questionID = item.QuestionID.replace(/\./g, ""); // example: 111
    const questionnaire = $("#qreResultContainer");
    const category = $(`#questionnaireCategory${ID}`);
    const subCategoryContainer = `#subCatContainer${subCatID}`;
    const subCategoryID = `subCat${subCatID}`;
    const questionTargetDiv = `questionTargetDiv${subCatID}`;
    const questionIdElm = `question${questionID}`;

    if (category.closest(questionnaire).length) {
      //console.log('category present');
    } else {
      appendCategory(location, item);
    }
    if (!document.getElementById(subCategoryID)) {
      appendSubCategory(location, item);
    }
    if (!document.getElementById(questionIdElm)) {
      appendQuestionItem(item);
    }
  }

  //Checkbox Style changes
  function colorParent(item) {
    const currentItem = $(item);
    const subCategoryItemElem = $(item).closest(".subCategoryItem");
    const questionItemElem = $(item).closest(".questionItem");

    if (item.checked === true && currentItem.hasClass("subCategoryCheckBox")) {
      subCategoryItemElem.addClass("selected");
    }
    if (item.checked === false && currentItem.hasClass("subCategoryCheckBox")) {
      subCategoryItemElem.removeClass("selected");
    }

    if (item.checked === true && currentItem.hasClass("questionCheckBox")) {
      questionItemElem.addClass("selected");
    }
    if (item.checked === false && currentItem.hasClass("questionCheckBox")) {
      questionItemElem.removeClass("selected");
    }
  }

  //Checks or Unchecks Boxes
  function check(targets, boolean) {
    var targets = $(targets);
    for (var i = 0; i < targets.length; i++) {
      targets[i].checked = boolean;
    }
    targets.trigger("change");
  }
  //Called when Category Checkbox is checked (tab)
  function checkSubCategories() {
    var targets = `.subCatCheck${this.id}`;
    this.checked ? check(targets, true) : check(targets, false);
  }
  //Called when Subcategory Checkbox is checked
  function checkAllQuestions() {
    var targets = `.questionCheck${this.id}`;
    this.checked
      ? (check(targets, true), colorParent(this))
      : (check(targets, false), colorParent(this));
  }
  //Called when question checkbox is checked
  function templateQuestions() {
    var questionObject = _.find(data, _.matchesProperty("QuestionID", this.id));
    var ID = questionObject.QuestionID.replace(/\./g, "");
    var questionItemToRemove = $(`#question${ID}`);
    var catID = questionObject.CategoryID;
    var location = $("#qreResultContainer");
    var subCatID = questionObject.SubCategoryID.replace(/\./g, ""); // example: 11
    var questionTargetDiv = $(
      `#questionTargetDiv${subCatID} .content-container`
    );
    var subCatContainerElm = $(`#subCatContainer${catID}`);

    if (this.checked === true) {
      colorParent(this);
      appendToQuestionnaire(location, questionObject);
    } else {
      colorParent(this);
      questionItemToRemove.remove();

      if (questionTargetDiv.children().length <= 0) {
        questionTargetDiv
          .closest(".subCatContainer")
          .find(`#subCat${subCatID}`)
          .remove();
      }

      if (subCatContainerElm.children().length === 0) {
        subCatContainerElm
          .closest("#qreResultContainer")
          .find(`#questionnaireCategory${catID}`)
          .remove();
      }
    }
  }
  //Binds change event to each box type
  $(document).on("change", ".categoryCheckBox", checkSubCategories);
  $(document).on("change", ".subCategoryCheckBox", checkAllQuestions);
  $(document).on("change", ".questionCheckBox", templateQuestions);
  /*******************END CHECKBOX BEHAVIOR*******************/
  /*******************FINALIZE*******************/
  $(".vcollapse-questionnaire").each(function (index) {
    $(this).vCollapse({
      onLoad: "none",
      any: true,
      speed: 300,
    });
  });
  /*******************END FINALIZE*******************/
});
